<template>
    <div>
        <template v-if="report_mode">
            <h3 class="mt-2 mb-3">Safety Program Report</h3>
        </template>
        <template v-else>
            <h3 class="mt-2 mb-3">Safety Program</h3>
        </template>

        <template v-if="(!report_mode && (viewSafetyProgram || viewResolution || viewExternalResolution)) || (report_mode && seeReport)">
            <vs-row>
                <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-0 pr-2 mb-base">
                    <vs-input
                        class="w-full"
                        placeholder="Type to Search"
                        v-model="filters.search"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="mb-base p-0">
                    <vx-tooltip text="Refresh Data" color="primary" >
                        <vs-button color="primary" type="filled" class="w-full" @click="load_data(filters)" :disabled="loading">
                            <font-awesome-icon :icon="redoIcon" />
                        </vs-button>
                    </vx-tooltip>
                    <template>
                        <vx-tooltip text="Create New Issue" color="primary" class="ml-2" v-if="!report_mode">
                            <router-link :to="{name: 'safety-program-new'}">
                                <vs-button color="primary" type="filled" class="w-full" :disabled="loading">
                                    <font-awesome-icon :icon="addIcon" />
                                </vs-button>
                            </router-link>
                        </vx-tooltip>
                    </template>
                    <vx-tooltip text="Create Excel" color="primary" class="ml-2" v-if="(report_mode && seeReport)">
                        <vs-button color="primary" type="filled" @click="create_excel"  class="ml-2" :disabled="loading">
                            <font-awesome-icon :icon="excel" />
                        </vs-button>
                    </vx-tooltip>
                </vs-col>
            </vs-row>
    
            <!-- Filters  -->
            <vs-row>
                <!-- created on date range filter  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectDate :selectedDate.sync="filters.date__gte" label="Date From" />
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.date__gte">
                        {{ api_errors.date__gte.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectDate :selectedDate.sync="filters.date__lte" label="Date To" />
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors.date__lte">
                        {{ api_errors.date__lte.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 mb-3 pr-3">
                    <SelectForeign
                        :model.sync="filters.program_type"
                        label="Filter By Type of Program"
                        placeholder="Type to Search..."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name',]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_type_of_programs}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectForeign
                        :model.sync="filters.assigned_reviewers"
                        label="Filter By Incident Manager"
                        placeholder="Type to Search..."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['first_name', 'last_name']"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectForeign
                        :model.sync="filters.reported_by"
                        label="Filter By Reporter"
                        placeholder="Type to Search..."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['first_name', 'last_name']"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
            </vs-row>
    
            <!-- excel Download  -->
            <template v-if="report_mode && ongoing_exports.length">
                <vs-alert color="primary" v-if="loading_exports">
                    Loading Latest Exports, please wait..
                </vs-alert>
                <template v-else>
                    <template v-for="(item, index) in ongoing_exports">
                        <vs-alert color="primary" :key="index" class="mb-2">
                            <template v-if="item.status == 'p'">
                                Your export is pending, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 's'">
                                Your export is in queue, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 'r'">
                                Your export is being generated, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 'c'">
                                Your export has been completed. (<FormatText :text="item.created_on" format="datetime" />) <a :href="item.export_excel" target="_blank" style="float:right;"><vs-button size="small">Download</vs-button></a>
                            </template>
                            <template v-else-if="item.status == 'f'">
                                Your export has been failed, please request again!
                            </template>
                        </vs-alert>
                    </template>
                </template>
            </template>
            
            <template v-if="(viewSafetyProgram || viewResolution || viewExternalResolution)">
                <vs-table class="freeze_row row2" :data="results" slot="no-body" :hoverFlat="true" stripe>
                    <vs-tr>
                        <vs-th>ID</vs-th>
                        <vs-th style="min-width: 120px;">Issue Date</vs-th>
                        <vs-th style="min-width: 120px;">Date Created</vs-th>
                        <vs-th style="min-width: 120px;">Closed Status</vs-th>
                        <vs-th style="min-width: 120px;">Closed On</vs-th>
                        <vs-th style="min-width: 120px;">Reporter Name</vs-th>
                        <vs-th style="min-width: 150px;">Incident Manager</vs-th>
                        <vs-th style="min-width: 180px;">Time of Activity(HH:MM)</vs-th>
                        <vs-th style="min-width: 120px;">Type of Program</vs-th>
                        <vs-th style="min-width: 120px;" v-if="report_mode">Location</vs-th>
                        <vs-th style="min-width: 120px;" v-if="report_mode">Beneficiaries</vs-th>
                        <vs-th style="min-width: 140px;" v-if="report_mode">Event Date</vs-th>
                        <vs-th style="min-width: 180px;" v-if="report_mode">Event Description</vs-th>
                        <vs-th style="min-width: 150px;" v-if="!report_mode">View Safety Program</vs-th>
                        <vs-th style="min-width: 120px;">Approval Status</vs-th>
                        <vs-th style="min-width: 120px;" v-if="!report_mode">View Resolution</vs-th>
                        <vs-th style="min-width: 150px;">Resolution Status (PO)</vs-th>
                        <vs-th style="min-width: 130px;">Resolution Status</vs-th>
                        <vs-th style="min-width: 130px;" v-if="!report_mode">Change Assignee</vs-th>
                        <vs-th style="min-width: 120px;" v-if="!report_mode">Delete Action</vs-th>
                    </vs-tr>
                    <template>
                        <template v-for="(item, index) in results">
                            <vs-tr :key="index">
                                <vs-td>
                                    {{ item.id }}
                                </vs-td>
                                <vs-td>
                                    <FormatText :text="item.date" format="date" />
                                </vs-td>
                                <vs-td>
                                    <FormatText :text="item.created_on" format="datetime" />
                                </vs-td>
                                <vs-td>
                                    <div :class="{'text-warning': item.closed_status =='p', 'text-danger': item.closed_status =='r', 'text-success': item.closed_status =='c', 'font-bold': true}">
                                        <FormatText :text="item.closed_status" format="select" :kwargs="[{label: 'Pending', value: 'p'},{label: 'Rejected', value: 'r'},{label: 'Completed', value: 'c'}]"  />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <template v-if="item.closed_on">
                                        <FormatText :text="item.closed_on" format="datetime" />
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </vs-td>
                                <vs-td>
                                    {{ item.reported_by.first_name }} {{ item.reported_by.last_name }}
                                </vs-td>
                                <vs-td>
                                    {{ item.assigned_reviewers.map(v => `${v.first_name} ${v.last_name}`).join(',') }}
                                </vs-td>
                                <vs-td>
                                    {{ item.time_of_activity }}
                                </vs-td>
                                <vs-td>
                                    {{ item.program_type ? item.program_type.name : ''}}
                                </vs-td>
                                <vs-td v-if="report_mode">
                                    {{ item.location }}
                                </vs-td>
                                <vs-td v-if="report_mode">
                                    {{ item.beneficiaries }}
                                </vs-td>
                                <vs-td v-if="report_mode">
                                    <FormatText :text="item.date" format="date" />
                                </vs-td>
                                <vs-td v-if="report_mode">
                                    {{ item.event_description }}
                                </vs-td>
                                <vs-td v-if="!report_mode">
                                    <template v-if="item.status == 'r' && editSafetyProgram(item)">
                                        <router-link :to="{name: 'safety-program-edit', params: {safety_program_id: item.id}}">
                                            <vs-button type="filled" size="small" color="primary">Edit</vs-button>
                                        </router-link>
                                    </template>
                                    <router-link :to="{name: 'safety-program-view', params: {safety_program_id: item.id}}" v-else>
                                        <vs-button type="filled" size="small" color="primary">View</vs-button>
                                    </router-link>
                                </vs-td>
                                <vs-td>
                                    <div v-if="item.status == 'p'" class="text-warning font-bold">
                                        Pending
                                    </div>
                                    <div v-else-if="item.status == 'r'" class="text-danger font-bold">
                                        Rejected
                                    </div>
                                    <div v-else-if="item.status == 'a'" class="text-success font-bold">
                                        Approved
                                    </div>
                                </vs-td>
                                <vs-td v-if="!report_mode">
                                    <router-link :to="{name: 'safety-program-resolution', params: {safety_program_id: item.id}}">
                                        <vs-button type="filled" size="small" color="primary">View</vs-button>
                                    </router-link>
                                </vs-td>
                                <vs-td>
                                    <div v-if="item.resolution_status_se == null" class="text-warning font-bold">
                                        Not Started/Applicable
                                    </div>
                                    <div v-else-if="item.resolution_status_se == 'p'" class="text-warning font-bold">
                                        Pending
                                    </div>
                                    <div v-else-if="item.resolution_status_se == 'r'" class="text-danger font-bold">
                                        Rejected
                                    </div>
                                    <div v-else-if="item.resolution_status_se == 'a'" class="text-success font-bold">
                                        Approved
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div v-if="item.resolution_status == null" class="text-warning font-bold">
                                        Not Started
                                    </div>
                                    <div v-else-if="item.resolution_status == 'p'" class="text-warning font-bold">
                                        Pending
                                    </div>
                                    <div v-else-if="item.resolution_status == 'r'" class="text-danger font-bold">
                                        Rejected
                                    </div>
                                    <div v-else-if="item.resolution_status == 'a'" class="text-success font-bold">
                                        Approved
                                    </div>
                                </vs-td>
                                <vs-td v-if="!report_mode">
                                    <template v-if="item.status == 'p' && changeSafetyProgramAssignee(item)">
                                        <vs-button @click="set_popup_data(index)" color="primary" type="filled" size="small">Change</vs-button>
                                        <vs-popup title="Change Assignee" :active.sync="popupActive">
                                            <div class="mb-3">
                                                <h6>Issue ID: #{{ popup_data.safety_program_id }}</h6>
                                                <span>Current Assignee: {{ popup_data.previous_assignee ? popup_data.previous_assignee.map(v => `${v.first_name} ${v.last_name}`).join(', ') : '' }}</span>
                                            </div>
                                            <SelectForeign
                                                :model.sync="popup_data.assigned_reviewers"
                                                label="Incident Manager"
                                                placeholder="Type to Search..."
                                                :multiple="true"
                                                :load_initial="true"
                                                :label_keys="['first_name', 'last_name']"
                                                :show_id_in_label="false"
                                                :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                                                container_class="w-full"
                                                input_class=""
                                                :use_id_as_value="false"
                                                :close_on_select="false"
                                                :disabled="submit_disabled"
                                                :use_cache="true"
                                            />
                                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.assigned_reviewers">
                                                {{ api_errors.assigned_reviewers.join(', ') }}
                                            </small>
                                            <vs-button @click="change_assignee()" class="mt-base" color="primary" type="filled" size="small" :disabled="submit_disabled">Save</vs-button>
                                        </vs-popup>
                                    </template>
                                    <template v-else>
                                        Can't Change Assignee
                                    </template>
                                </vs-td>
                                <vs-td v-if="!report_mode">
                                    <template v-if="delete_permission(item)">
                                        <vx-tooltip text= "Delete" color="danger">
                                            <vs-button @click="() => {
                                                delete_popup.id = item.id
                                                delete_popup.active = true
                                            }" size="small" type="flat">
                                                <font-awesome-icon size="2x" class="text-danger" :icon="deleteIcon"/>
                                            </vs-button>
                                        </vx-tooltip>
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </template>
                </vs-table>
        
                <DeletePopup :is_active.sync="delete_popup.active" type="safety program" @delete_issue="delete_issue" />
        
                <template v-if="!disable_pagination">
                    <vs-row v-if="total_results" class="mt-3 text-center">
                        <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
                    </vs-row>
                </template>
            </template>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>

    </div>
</template>

<script>
import { faPlus, faRedo, faFileExcel, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Request } from "../../utils/requests";
import DeletePopup from '../components/DeletePopup.vue';
import moment from 'moment';

export default {
    props: {
        embedded_mode: {
            required: false,
            default: false
        },
        embedded_filters: {
            required: false,
            default: () => {}
        },
        disable_pagination: {
            required: false,
            default: false
        },
        global_mode: {
            required: false,
            type: Boolean,
            default: false
        },
        report_mode: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    components: {
        DeletePopup
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 20);

        let current_page = Math.ceil((offset + limit) / limit);
        return  {
            results: [],

			next_url: null,
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                ordering: this.$route.query.ordering || [],
                offset: offset,
                limit: limit,
            },

            filters_init: false,

            reject_popup: {
                active: false,
                comment: null,
                item: null,
                api_errors: {}
            },

            delete_popup: {
                active: false,
                id: null
            },

            submit_disabled: false,
            api_errors: {},

            loading_exports: false,
            ongoing_exports: [],

            //for change assignee
            popupActive: false,
            popup_data: {
                safety_program_id: null,
                previous_assignee: null,
                assigned_reviewers: [],
            },
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
        redoIcon: () => faRedo,
        addIcon: () => faPlus,
        excel: () => faFileExcel,
        deleteIcon: () => faTrash,
        viewSafetyProgram() { 
            return this.hasAccess('read', `safety_program`, 'any')
        },
        viewResolution() { 
            return this.hasAccess('read_resolution', `safety_program`, ['all', 'assigned'])
        },
        viewExternalResolution() {
            return this.hasAccess('read_external_resolution', `safety_program`, ['all', 'assigned'])
        },
        seeReport() {
            return this.hasAccess('read', `safety_program_report`, 'all')
        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (!this.filters_init) return

                if (this.current_page == null) return;

                if (this.timer) clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.$router.push({ name: this.$route.name, query: {...newV, ...this.embedded_query_params} });
                }, 800);
            }
        },
        "$route.query"(newV) {
            this.load_data(newV);
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        },
    },
    beforeDestroy() {
        if (this.export_timer) clearTimeout(this.export_timer)
    },
    methods: {
        init(){
            this.load_filters()
        },
        calculate_page() {
            if (this.filters.offset == 0) this.current_page = 1;
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
        },
        load_data(filters=null) {

            // checking for created_on date range filters
            if (filters.date__gte && !filters.date__lte) {
                this.api_errors = {
                    "date__lte": [
                        "Date To should be there.",
                    ]
                }
                return

            } else if(filters.date__lte && !filters.date__gte) {
                this.api_errors = {
                    "date__gte": [
                        "Date From should be there.",
                    ]
                }
                return
            }
            
            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.safety_programs

            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            this.api_errors = {}

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                    this.$vs.loading.close();
                    if(this.report_mode) this.refresh_exports()
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Unable to load Pipelines. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_filters() {

            this.filters_init = false
            this.filters = {
                search: this.filters.search,
                ordering: this.filters.ordering,
                offset: this.filters.offset,
                limit: this.filters.limit,
                date__lte: null,
                date__gte: null,
                assigned_reviewers: null,
                reported_by: null,
                program_type: null
            }

            this.filters_init = true
        },
        refresh_exports() {
            this.loading_exports = true

            let url = this.$store.state.apiendpoints.excel_list

            let payload = {
                created_on: moment().format('YYYY-MM-DD'),
                module_key: 'o',
                params__report_type: 'safety_program',
                limit: 4
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.ongoing_exports = res.results
                    this.loading_exports = false
                    if(this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
                }, 
                (err) => {
                    this.loading_exports = false;
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Unable to load current exports, please refresh to try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        auto_refresh_export() {
            this.export_timer = setTimeout(() => {
                this.refresh_exports()
            }, 5000);
        },
        create_excel() {

            this.loading = true;
            this.$vs.loading();

            let corrected_keys = {}

            Object.keys(this.filters).filter((key) => !['search', 'ordering', 'offset', 'limit'].includes(key) && this.filters[key]).forEach(key => {
                corrected_keys[key] = this.filters[key]
            })

            let payload = {
                module_key: 'o',
                params: {
                    "report_type": 'safety_program',
                    "filters": corrected_keys
                }
            }

            let url = this.$store.state.apiendpoints.excel_create

            Request(this, 'POST', url, null, payload).then(
                (res) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    this.refresh_exports()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Success',
                        text: "Your request to download file has been submitted",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        set_popup_data(index) {
            this.popup_data.safety_program_id = this.results[index].id
            this.popup_data.previous_assignee = this.results[index].assigned_reviewers
            this.popupActive = true
        },
        change_assignee() {

            if(this.popup_data.assigned_reviewers.length == 0) {
                this.api_errors = {
                    "assigned_reviewers": [
                        "Please select atleast 1 Incident Manager.",
                    ]
                }

                return
            }

            let payload = {
                action: 'change_assignee',
                assigned_reviewers: this.popup_data.assigned_reviewers.map(v => v.id)
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.popup_data.safety_program_id), null, payload).then(
                (res) => {
                    this.submit_disabled = false
                    this.$vs.loading.close()
                    this.popupActive = false
                    this.popup_data.assigned_reviewers = []

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })

                    this.$router.push({name: 'safety-program-list'})
                },
                err => {
                    this.submit_disabled = false
                    this.$vs.loading.close()
                    this.popupActive = false
                    this.popup_data.assigned_reviewers = []

                    if (err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An server error occurred while processing your request.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        deleteSafetyProgram(item) {
            let user_ids = item.assigned_reviewers.map(v=>v.id)
            user_ids.push(item.reported_by.id)
            return this.hasAccess('delete', `safety_program`, 'any', user_ids)
        },
        delete_permission(item) {
            if(!this.deleteSafetyProgram(item)) return false

            const issue_month = (new Date(item.created_on)).getMonth()
            const current_month = (new Date()).getMonth()

            if(issue_month==current_month) return true

            return false
        },
        delete_issue() {

            let url = this.$store.state.apiendpoints.safety_program + this.delete_popup.id + "/"
            this.disabled = true

            Request(this, 'DELETE', url, null, null).then(
                (res) => {
                    // after successful deletion removing from results
                    this.results = this.results.filter(obj => obj.id != this.delete_popup.id)
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'Safety program deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        changeSafetyProgramAssignee(item) { 
            return this.hasAccess('edit', `safety_program`, ['all', 'own'], [item.reported_by.id]) 
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__safety_program`)
            permission.push(`review__assigned__safety_program`)

            return permission.toString()
        
        },
        editSafetyProgram(item) { 
            return this.hasAccess('edit', `safety_program`, ['all', 'own'], [item.reported_by.id])
        }
    }
}
</script>
